import React, { useState } from "react";
import MultiButtonSelect from "./MultiButtonSelect";
import { statesWithAbbr } from "./states";

const designation = [
  {
    name: "National Park",
    abbreviation: "National Park",
  },
  {
    name: "National Historic Park",
    abbreviation: "National Historic Park",
  },
];

export default function ControlBar() {
  const [currentActiveFilter, setCurrentActiveFilter] = useState();

  // useEffect(() => {
  //   console.log(selection);
  // }, [selection]);
  return (
    <div className="mt-4 flex gap-2">
      <MultiButtonSelect
        name="states"
        label="States"
        filterOptions={statesWithAbbr}
        isVisible={currentActiveFilter === "states"}
        setCurrentActiveFilter={setCurrentActiveFilter}
      />
      <MultiButtonSelect
        name="designation"
        label="Park Type"
        filterOptions={designation}
        isVisible={currentActiveFilter === "designation"}
        setCurrentActiveFilter={setCurrentActiveFilter}
      />
    </div>
  );
}
